import { useState, useEffect, useContext } from "react";
import {
	Request,
	catchErrorHandle,
	CTX_STATE,
	CTX_DISPATCH,
	sysMsg,
	logOut,
	isNumber,
} from "../common";

let order_sn = null;

export default function App(initial) {
	//通用
	const { isShow, from, onClose } = initial;
	//游戏购买特殊处理
	const {
		isWjyz,
		payPrice,
		img_url,
		payId,
		list_img,
		buyCount: num = 1,
	} = initial;

	const [platform, setPlatform] = useState(initial.platform);
	//游戏购买特殊处理
	const [productList, setProductList] = useState(
		Array.isArray(initial.productList) ? initial.productList : []
	);
	const [product, setProduct] = useState(null);
	//游戏购买特殊处理
	const [payType, setPayType] = useState(
		typeof initial.payType === "number" ? initial.payType : null
	);
	const [agree, setAgree] = useState(true);
	const [qrcode, setQrcode] = useState(null);
	const [time, setTime] = useState(-1); // -1: 初始状态  0: 过期
	const [refresh, setRefresh] = useState(false);
	const [paySucc, setPaySucc] = useState(false);
	const _state = useContext(CTX_STATE);
	const _dispatch = useContext(CTX_DISPATCH);

	useEffect(() => {
		if (!isShow || !["JsqPay", "MemberPay"].includes(from)) return;

		let data = {};

		if (from === "JsqPay") {
			data = {
				p_type: 10,
				platform_id: platform === "yebao" ? 1 : 0,
			};
		} else if (from === "MemberPay") {
			data = {
				p_type: 1,
				platform_id: 2,
			};
		}

		const req = new Request({
			url: "/api/order/v1/product",
			source: 2,
			data,
		});

		const getData = async () => {
			try {
				const res = await req.send();

				if (res.base.code === "200" && res.data) {
					if (from === "JsqPay") {
						setProductList(res.data.slice(0, 4));
					} else if (from === "MemberPay") {
						setProductList(res.data.slice(0, 3));
					}

					setProduct(0);
					setPayType(0);
				} else {
					throw new Error(res.base.msg);
				}
			} catch (error) {
				sysMsg({
					msg: catchErrorHandle(error),
				});
			}
		};

		getData();

		return () => {
			req.cancel();
		};
	}, [isShow, platform, from]);

	useEffect(() => {
		setPaySucc(false);

		setTime(-1);

		const { barid, channel_number = "" } = window.mbQuery?.appInfo || {};
		let data = {};

		if (from === "JsqPay") {
			if (!isShow || product === null || payType === null || !agree) return;

			data = {
				ch_type: 0,
				pay_type: payType,
				channel_number,
				product_id: productList[product]["id"],
				product_amount: productList[product]["productPrice"],
				jsq_img: platform,
			};
		} else if (from === "GamePay") {
			if (!isShow || payType === null || !agree) return;

			data = {
				ch_type: 0,
				pay_type: payType,
				game_amount: payPrice,
				channel_number,
			};

			if (isWjyz) {
				data.wjyz_id = payId;
			} else {
				data.game_id = payId;
			}

			if (product !== null) {
				data = {
					...data,
					product_id: productList[product]["id"],
					product_amount: productList[product]["productPrice"],
					jsq_img: product === 0 ? "yebao" : "ak",
				};
			}
		} else if (from === "MemberPay") {
			if (!isShow || product === null || payType === null || !agree) return;

			data = {
				ch_type: 0,
				pay_type: payType,
				channel_number,
				product_id: productList[product]["id"],
				product_amount: productList[product]["productPrice"],
			};
		}

		barid &&
			isNumber(barid) &&
			(data = {
				...data,
				ch_type: 1,
				channel_number: barid,
			});

		data = {
			...data,
			num,
		};

		const req = new Request({
			url: "/api/order/v1/create_order",
			source: 2,
			method: "post",
			headers: {
				token: _state.token,
			},
			data,
		});

		const getData = async () => {
			try {
				const res = await req.send();

				if (res.base.code === "200") {
					const data = res.data || {};
					order_sn = data?.orderSn;
					setQrcode(data.url?.ret);
					setTime(60);
				} else if (res.base.code === "403") {
					onClose();
					logOut(_dispatch, true);
				} else {
					throw new Error("error");
				}
			} catch (error) {
				sysMsg({
					msg: "下单失败，请联系客服",
				});
			}
		};

		getData();

		return () => {
			req.cancel();
		};
	}, [
		isShow,
		_state.token,
		_dispatch,
		platform,
		productList,
		product,
		payType,
		agree,
		onClose,
		refresh,
		from,
		img_url,
		isWjyz,
		list_img,
		payId,
		payPrice,
		num,
	]);

	useEffect(() => {
		const timer = setTimeout(() => {
			if (time > 0) {
				const req = new Request({
					url: "/api/order/v1/order_status",
					source: 2,
					method: "post",
					data: { order_sn },
				});

				const getData = async () => {
					try {
						const res = await req.send();

						if (res.base.code === "200" && res.data?.status === "1") {
							setTime(-1);
							onClose();
							setPaySucc(true);
						}
					} catch (error) {
						console.log(catchErrorHandle(error));
					}
				};

				getData();

				setTime((c) => c - 1);
			}
		}, 1000);

		return () => {
			clearTimeout(timer);
		};
	}, [time, platform, productList, product, onClose]);

	return {
		platform,
		setPlatform,
		productList,
		product,
		setProduct,
		payType,
		setPayType,
		agree,
		setAgree,
		qrcode,
		time,
		setRefresh,
		paySucc,
	};
}
